import React from 'react';
import { Cadence } from '../../types/howItWorks';
import { cadenceStyles } from './cadenceStyles';
export function CadencePill({
  cadence
}: {
  cadence: Cadence;
}) {
  const style = cadenceStyles[cadence];
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-semibold ${style.bg} ${style.border} ${style.text}`} data-id="element-304" data-mp="3amhj4gp9jshm">
      <span className={`h-1.5 w-1.5 rounded-full ${style.solid}`} aria-hidden="true" data-id="element-305" data-mp="30pwcjqxli9bo" />
      {style.label}
    </span>;
}